import React from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { TabViewValues } from "../../ReusableComponents/CommonFunctions";
const QuestionStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const Tabs = [
    { Name: "Scenario based Questions", Value: "SCQ" },
    { Name: "Direct Questions", Value: "DQ" },
    { Name: "Input based Questions", Value: "INQ" },
  ];

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <TabViewValues
          Tabs={Tabs}
          Selectedtab={location.state?.Tab}
          onClick={(e) => {
            navigate(`/QBAdmin/QuestionStatus`, { state: { Tab: e } });
          }}
        />
        <Outlet />
      </div>
    </>
  );
};
export default QuestionStatus;
